// extracted by mini-css-extract-plugin
module.exports = {"dayPanel":"DayCard_dayPanel__3pCF0","movieLink":"DayCard_movieLink__1RBo1"};